let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jT9wv")).then(() => parcelRequire('aj53f'));